import React from "react"
import PropTypes from "prop-types"
import { useSubscription } from "react-apollo"
import { useGenericError } from "@modules/modal"
import { MdArrowForward } from "react-icons/md"
import { VERCEL_ADDED_SUBSCRIPTION } from "../queries"
import { Button, StyledModalActions, Text } from "gatsby-interface"
import { vercelIntegrationConfig as text } from "@modules/locales/default.json"
import LoadingFromExternalWindow from "@modules/ui/components/LoadingFromExternalWindow"
import { commonMessageTags, FormattedMessage } from "@modules/locales"

const propTypes = {
  siteName: PropTypes.string.isRequired,
  siteId: PropTypes.string.isRequired,
  onConnect: PropTypes.func.isRequired,
}

const useOpenVercelWindow = siteId => {
  const [isWindowOpened, setIsWindowOpened] = React.useState(false)

  const openWindow = () => {
    setIsWindowOpened(true)

    window.open(
      `${process.env.GATSBY_DASHBOARD_AUTHENTICATION_URL}/oauth/now?siteId=${siteId}`,
      `_blank`,
      `height=600,width=700`
    )
  }

  return [isWindowOpened, openWindow]
}

const useVercelConnect = (siteId, onConnect) => {
  const throwError = useGenericError()

  const { error } = useSubscription(VERCEL_ADDED_SUBSCRIPTION, {
    variables: {
      siteId,
    },
    onSubscriptionData: data =>
      onConnect(data.subscriptionData.data.nowIntegrationAdded),
  })

  React.useEffect(() => {
    if (error) {
      throwError({ message: error.message })
    }
  }, [error])
}

export function ConnectVercel({ siteName, siteId, onConnect }) {
  const [isWindowOpened, openWindow] = useOpenVercelWindow(siteId)

  useVercelConnect(siteId, onConnect)

  if (isWindowOpened) {
    return (
      <LoadingFromExternalWindow
        style={{ minHeight: `auto` }}
        message={text.messages.authorizingVercel}
        onClick={openWindow}
      />
    )
  }

  return (
    <React.Fragment>
      <Text>
        <FormattedMessage
          message={text.headers.connectToSite}
          values={{ siteName }}
          tags={commonMessageTags}
        />
      </Text>
      <StyledModalActions>
        <div />
        <Button onClick={openWindow} rightIcon={<MdArrowForward />}>
          {text.actions.connect}
        </Button>
      </StyledModalActions>
    </React.Fragment>
  )
}

ConnectVercel.propTypes = propTypes
